import axios from "axios";
import { downloadBlob, getFilenameFromContentDisposition } from "./markingPreviewWindow";

/** Downloads the uploaded input file of a reproduction of any type (logo
 * SVG, image, gradient shape) under its original name; resolves to that
 * name, rejects when the request fails. */
export async function downloadReproductionSource(reproductionId, fallbackName) {
    const response = await axios.post(
        "api/reproduction/source/download",
        { reproduction_id: reproductionId },
        { responseType: "blob" },
    );
    const filename = getFilenameFromContentDisposition(response.headers?.["content-disposition"])
        || fallbackName || "reproduction_input";
    downloadBlob(response.data, filename);
    return filename;
}
